/* eslint-disable max-len */
import './Privacy.scss';
import React, { useEffect, useState } from 'react';
import { scrollTop, showError } from 'utils';
import { SanitizedHtml, Spin } from 'library';
import { SETTINGS_KEYS, SettingsService } from 'modules/settings';
import Header from 'containers/Header';

const PrivacyRoute = () => {
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        SettingsService.get(SETTINGS_KEYS.privacy)
            .then((data) => {
                if (data.length) {
                    setText(data[0].value);
                    setTimeout(() => {
                        scrollTop();
                    }, 0);
                }
            })
            .finally(() => setLoading(false))
            .catch(showError);
    }, []);

    return (
        <Spin spinning={loading}>
            <Header />
            <div className="wrapper wrapper-policy">
                <h1>Privacy Policy</h1>
                <SanitizedHtml>
                    {text}
                </SanitizedHtml>
            </div>
        </Spin>

    );
};

export default PrivacyRoute;
